import type { ValueOf } from '@src/shared/types/utilities';

export const FILTER_COLOR = {
  red: '#ef4444',
  orange: '#f97316',
  yellow: '#eab308',
  green: '#22c55e',
  teal: '#14b8a6',
  blue: '#3b82f6',
  indigo: '#6366f1',
  purple: '#a855f7',
  pink: '#ec4899',
  slate: '#64748b',
} as const;

export type TFilterColor = ValueOf<typeof FILTER_COLOR>;
